import { createBrowserRouter } from 'react-router-dom'
import { createManifestRouteObjects } from '@/core/routing/manifestRouter'

export const router = createBrowserRouter(createManifestRouteObjects())
